import React, { useEffect, useState } from "react";
import Book from "../Book/Book";
import Header from "../Header/Header";

const Books = ({ AddTimeToExercise }) => {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    fetch("data.json")
      .then((res) => res.json())
      .then((data) => setBooks(data));
  }, []);

  return (
    <div className="mx-md-5 px-md-4">
      <Header></Header>
      <div className="row row-cols-1 row-cols-md-3 gy-4 gx-4 mt-3">
        {books.map((book) => (
          <Book
            key={book.id}
            book={book}
            AddTimeToExercise={AddTimeToExercise}
          ></Book>
        ))}
      </div>
    </div>
  );
};

export default Books;
